import { useFormContext } from 'react-hook-form';
import React from 'react';
import { Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useModal } from 'store/modals';
import { useAccessManagement2NModal } from '../../../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import { discardChanges } from '../../../../../../discardChanges';
import styles from './styles.module.scss';

export const FormActions = ({ isLoading, onSubmit }) => {
 
  const intl = useIntl();
  const modal = useModal();
  const formContext = useFormContext();
  const { formState } = formContext;
  const accessManagement2NModal = useAccessManagement2NModal();

  return (
    <div className={styles.actionContainer}>
      <div className={styles.formActions}>
        <Button
          basic
          name="cancel-add-time-profile"
          type="button"
          disabled={isLoading}
          onClick={() => discardChanges('timeProfile', null, intl, accessManagement2NModal, modal)}
        >
          <FormattedMessage id="cancel" />
        </Button>
        <Button
          primary
          name="submit-add-time-profile"
          disabled={!formState.isDirty || isLoading}
          loading={isLoading}
          onClick={formContext.handleSubmit(onSubmit)}
        >
          <FormattedMessage id="addNewTimeProfile" />
        </Button>
      </div>
    </div>
  );
};
